import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule  } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutComponent } from './_layout/app-layout/app-layout.component'
import { AppHeaderComponent } from './_layout/app-header/app-header.component'
import { AppFooterComponent } from './_layout/app-footer/app-footer.component';
import { OwnerDashboardComponent } from './ownerdashboard/ownerdashboard.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ChartsModule } from 'ng2-charts';
import { ReferralsComponent } from './referrals/referrals.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxGaugeModule } from 'ngx-gauge';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './auth/login.component';
import { PaymentService } from './services/payment.service';
import { SessionService } from './services/session.service';
import { UpdateProfileComponent } from './tenant-dashboard/update-profile/update-profile.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RoomAllocAndProfileComponent } from './tenant-dashboard/room-alloc-and-profile/room-alloc-and-profile.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxPrintModule} from 'ngx-print';
import { ToastrModule } from 'ngx-toastr';
import { TenantDashboardComponent } from './tenant-dashboard/dashboard/dashboard.component';
import { GoldenPropertiesComponent } from './golden-properties/golden-properties.component';
import { PropertyDetailComponent } from './property-detail/property-detail.component';

import { SearchlistComponent } from './searchlist/searchlist.component';
import { StaticPageComponent } from './static-page/static-page.component';
import { CareersComponent } from './careers/careers.component';
import { BecomeOwnerComponent }  from './becomeowner/becomeowner.component';
import { TopLivingAreasComponent } from './top-living-areas/top-living-areas.component';
import { UploadDocsAndRefsComponent } from './tenant-dashboard/upload-docs-and-refs/upload-docs-and-refs.component';

import { AgmCoreModule } from '@agm/core';
import { InvestorComponent } from './investor/investor.component';
import { EditprofileComponent } from './editprofile/editprofile.component';
import {CatalogueComponent} from './becomeowner/catalogue/catalogue.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { FaqComponent } from './faq/faq.component';
import { TeamComponent } from './team/team.component';
import { ResetComponent } from './auth/reset.component';

import { PageNotFoundComponent } from './404/pagenotfound.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { CsatComponent } from './csat/csat.component';
import { NewHomeComponent } from './new-home/new-home.component';
import { TenantsComponent } from './tenants/tenants.component';
import { PropertyManagerComponent } from './property-manager/property-manager.component';
import { TenantDbComponent } from './new-tenant-dashboard/tenantdb.component';

import { LeadershipComponent } from './leadership/leadership.component';

import { FiveRingsComponent } from './partnerships/fiverings/fiverings.component';
import { AbhiHomesComponent } from './partnerships/abhihomes/abhihomes.component';
import { AgserHomesComponent } from './partnerships/agserhomes/agserhomes.component';
import { YgcComponent } from './partnerships/ygc/ygc.component';
import { EqaroComponent } from './partnerships/eqaro/eqaro.component';

@NgModule({
  declarations: [
    AppComponent,
    OwnerDashboardComponent,
    ReferralsComponent,
    AppHeaderComponent,
    AppLayoutComponent,
    AppFooterComponent,
    LoginComponent,
    UpdateProfileComponent,
    RoomAllocAndProfileComponent,
    TenantDashboardComponent,
    GoldenPropertiesComponent,
    PropertyDetailComponent,
    SearchlistComponent,
    StaticPageComponent,
    CareersComponent,
    BecomeOwnerComponent,
    TopLivingAreasComponent,
    UploadDocsAndRefsComponent,
    InvestorComponent,
    EditprofileComponent,    
    CatalogueComponent,
    TestimonialsComponent,
    FaqComponent,
    TeamComponent,
    PageNotFoundComponent,
    ResetComponent,    
    CsatComponent,
    NewHomeComponent,
    TenantsComponent,
    PropertyManagerComponent,
    LeadershipComponent,
    TenantDbComponent,
    FiveRingsComponent,
    AbhiHomesComponent,
    AgserHomesComponent,
    YgcComponent,
    EqaroComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgSelectModule,
    FormsModule,
    FontAwesomeModule,
    NgxQRCodeModule,
    HttpClientModule,
    ChartsModule,
    NgxGaugeModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    BsDatepickerModule.forRoot(),
    NgxPrintModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDLvbSSc2gfr-3tBNZv9guEAW2Bs3FMv44',
      libraries: ['places']
    }),
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 16,
      outerStrokeColor: "#78C000",
      subtitle: "Months Remaining",
      subtitleFontSize: "24",
      showUnits: false,
      subtitleColor: "black",
      animationDuration: 300,
    }),
    NgbModule,
  ],
  providers: [SessionService, PaymentService],
  bootstrap: [AppComponent]
})
export class AppModule { }
